import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import dog from "./dog.png";
import TableRow from "@material-ui/core/TableRow";
import { TableCell } from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  searchQuery: string;
};

const searchResultsWereSorryMessage = "We’re sorry - we can’t find results for";
const noSearchWereSorryMessage = "We’re sorry - we can’t find any results.";

const ZeroResults = ({ searchQuery }: Props) => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell colSpan={8} padding="none">
        <Grid
          id="zero-search-results"
          container
          className={classes.border}
          justify="center"
          alignContent="center"
        >
          <Grid item xs={2}>
            <img
              src={dog}
              className={classes.image}
              alt="Sorry, our dog Charlie couldn’t find any matches for your search"
            />
          </Grid>
          <Grid item xs={7} className={classes.textContainer}>
            <Typography variant="h2" className={classes.sorry}>
              {searchQuery
                ? searchResultsWereSorryMessage
                : noSearchWereSorryMessage}
            </Typography>
            {!!searchQuery && (
              <Typography
                variant="h2"
                className={classes.searchInput}
              >{`“${searchQuery}”`}</Typography>
            )}
            <Typography variant="body1">
              Try adjusting your search or filter parameters
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ZeroResults;
